import { Colors, Storage } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';

let profileInfo;

export default class AutoPlay extends Lightning.Component {
  static _template() {
    return {
      Title: {
        y: 615,
        x: 360,
      },
      CurrentValue: {
        y: 620,
        x: 970,
        text: { textColor: Colors('#FAFAFA').get(), fontFace: 'OpenSans-Regular', fontSize: 36 },
      },
      Border: {
        x: 320,
        y: 605,
        collision: true,
        texture: Lightning.Tools.getRoundRect(847, 70, 13, 4, Colors('#000000').get(), false),
      },
    };
  }

  get _Title() {
    return this.tag('Title');
  }

  get _Border() {
    return this.tag('Border');
  }

  get _CurrentValue() {
    return this.tag('CurrentValue');
  }

  set profileId(val) {
    return (this._profileId = val);
  }

  _handleEnter() {
    switch (this._CurrentValue.text._text) {
      case 'On':
        this._CurrentValue.patch({ text: { text: 'Off' } });
        break;
      case 'Off':
        this._CurrentValue.patch({ text: { text: 'On' } });
    }
  }

  _firstEnable() {
    profileInfo = Storage.get(this._profileId);
    this._Title.patch({
      color: Colors('#D6D6D6').get(),
      text: {
        text: 'Autoplay',
        textColor: Colors('#D6D6D6').get(),
      },
    });

    this._CurrentValue.patch({
      text: {
        textColor: Colors('#D6D6D6').get(),
        text: profileInfo.profileAutoplay ? 'On' : 'Off',
      },
    });
  }

  _focus() {
    this._Title.patch({
      color: Colors('#fafafa').get(),
    });
    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(847, 70, 13, 4, Colors('#02AC25').get(), false),
    });
    this._CurrentValue.patch({
      text: {
        textColor: Colors('#fafafa').get(),
      },
    });
  }

  _unfocus() {
    this._Title.patch({
      color: Colors('#D6D6D6').get(),
    });

    this._Border.patch({
      texture: Lightning.Tools.getRoundRect(847, 70, 13, 4, Colors('#000000').get(), false),
    });

    this._CurrentValue.patch({
      text: {
        textColor: Colors('#D6D6D6').get(),
      },
    });
  }

  _handleHover() {
    this.fireAncestors('$setState', 'Autoplay');
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }
}
